<template>
    <div>
        <p>{{ token }}</p>
        <p>{{ metadata }}</p>
    </div>
</template>

<script>
import PlaidService from '../services/PlaidService';

export default {
    data() {
        return {
            token: '',
            metadata: '',
            plaidConfig: {
                onSuccess: this.onSuccess,
                onExit: this.onExit,
            },
        };
    },
    methods: {
      onSuccess(token, metadata) {
          this.token = token;
          this.metadata = JSON.stringify(metadata);
      },
      onExit(err, metadata) {
          if (err) {
              if (err.error_code === 'item-no-error') {
                  this.$emit('updated');
                  return true;
              } else {
                  this.$swal({
                      type: 'error',
                      title: 'Plaid Error',
                      text: PlaidService.handleError(err),
                  });
              }
          }
      },
    },
    mounted() {
        this.plaidService = null;
        this.plaidService = new PlaidService();
        this.plaidService.init()
            .then(() => {
              return Vue.backendApi().user(this.$store.state.user.id)
                  .createPlaidAccountDetailsLinkToken()
                  .then((response) => response.data);
            })
            .then((linkTokenResponse) => {
                const config = {
                  ...this.plaidConfig,
                  token: linkTokenResponse.link_token,
                };

                console.log('plaidConfig', config);
                this.plaidLoaded = true;
                this.plaidService.create(config);
                this.plaidService.open();
            })
            .catch(err => {
                this.initializing = false;
                this.$swal({
                    type: 'error',
                    title: 'Plaid error',
                    text: err.message ? err.message : err,
                });
            });
    },
};
</script>

<style lang="css" scoped>
</style>
